export const CATEGORY_META = {
  sleep: { label: "Sleep", emoji: "🌙", tint: "from-indigo-100 to-slate-50", chip: "bg-indigo-100 text-indigo-800" },
  exercise: { label: "Exercise", emoji: "💪", tint: "from-orange-100 to-amber-50", chip: "bg-orange-100 text-orange-800" },
  productivity: { label: "Productivity", emoji: "⚡", tint: "from-amber-100 to-yellow-50", chip: "bg-amber-100 text-amber-800" },
  nutrition: { label: "Nutrition", emoji: "🥗", tint: "from-emerald-100 to-lime-50", chip: "bg-emerald-100 text-emerald-800" },
  mindfulness: { label: "Mindfulness", emoji: "🧘", tint: "from-teal-100 to-cyan-50", chip: "bg-teal-100 text-teal-800" },
  social: { label: "Social", emoji: "🤝", tint: "from-rose-100 to-pink-50", chip: "bg-rose-100 text-rose-800" },
  learning: { label: "Learning", emoji: "📚", tint: "from-sky-100 to-blue-50", chip: "bg-sky-100 text-sky-800" },
  other: { label: "Other", emoji: "✨", tint: "from-stone-100 to-neutral-50", chip: "bg-stone-100 text-stone-800" },
};

export const LEVEL_COLORS = {
  Platinum: "bg-gradient-to-r from-slate-300 to-slate-500 text-white",
  Gold: "bg-gradient-to-r from-amber-300 to-amber-500 text-white",
  Silver: "bg-gradient-to-r from-slate-200 to-slate-400 text-white",
  Bronze: "bg-gradient-to-r from-orange-300 to-orange-500 text-white",
  Sprout: "bg-emerald-100 text-emerald-800",
};
